import React from "react";
import { useLocale } from "@/contexts/LocaleContext";
import Logo from "@/components/Logo";

export default function Footer() {
  const { t } = useLocale();
  return (
    <footer className="mt-20 border-t border-border surface-soft">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <Logo variant="full" className="h-12 w-auto" />
          <p className="mt-4 text-sm text-muted-foreground max-w-xs">{t("footer.tagline")}</p>
        </div>
        <div className="text-sm text-muted-foreground">
          <div className="label-eyebrow mb-3">República Dominicana</div>
          <p>Santo Domingo · Santiago · Punta Cana · Puerto Plata · La Romana</p>
        </div>
        <div className="text-sm text-muted-foreground md:text-right">
          © {new Date().getFullYear()} To2casa. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
